import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { emptyCart, setCustomer } from '../../../../actions/cart';
import UsersService from '../../../../services/UsersService';
import Spinner from '../../../Common/Spinner';

import AddItemPage from './AddItemPage';

function AddItemPageContainer(props) {
  const { id_user, id_orders } = useParams();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const { doSetCustomer } = props;

    // Restore the initial state for the cart in the beginning of the purchase flow
    emptyCart();
    UsersService.getUser(id_user).then((user) => {
      doSetCustomer(user);

      setIsReady(true);
    });
  }, []);

  const { doEmptyCart, customer } = props;

  if (!isReady) {
    return <Spinner />;
  }

  return <AddItemPage orderId={id_orders} user={customer} onEmptyCart={doEmptyCart} {...props} />;
}

function mapStateToProps(state) {
  return {
    customer: state.cart.customer,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      doEmptyCart: emptyCart,
      doSetCustomer: setCustomer,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddItemPageContainer);
